export default __webpack_public_path__ + "static/media/comp-bnr-small.2aa894f3.jpg";